(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6569],{

/***/ 2779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment productListInformation on Product {\n    _id\n    name\n    description\n    nicknames\n    altImg\n    titleImg\n    images {\n      _id\n      url\n      # colors {\n      #   blurhash4x4\n      # }\n      imageSmall: resizedURL(width: 320, height: 320, format: $format)\n    }\n    availabilityAt(menuId: $menuId) {\n      basePrice\n      finalPrice\n      pastPrices\n      hasDiscount\n      available\n      notAvailableMessage\n      hideDiscountBadge\n    }\n    isOutOfStock(storeId: $storeId, deliverAt: $deliverAt)\n    menu(menuId: $menuId) {\n      _id\n      channels\n    }\n    modifiers {\n      _id\n      description\n      isImageModifier\n      max\n      min\n      name\n      optional\n      options {\n        _id\n        requiresModifierOptionIds\n        requiresAtLeastOneModifierOption\n        availabilityAt(menuId: $menuId) {\n          available\n          menuId\n          price\n        }\n        max\n        name\n      }\n    }\n    informativeStamps\n    promotions {\n      _id\n      promotionType\n    }\n    filterIds\n    timesPurchased\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ __webpack_exports__["Z"] = ((0,graphql_tag__WEBPACK_IMPORTED_MODULE_0__["default"])(_templateObject()));


/***/ }),

/***/ 81820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getOrderPath; }
/* harmony export */ });
function getOrderPath(router, website) {
    if (typeof router.query.isChat === "string" && router.query.isChat === "true") {
        return "/chat/".concat(website._id, "/order");
    }
    return "/pedir";
};


/***/ }),

/***/ 55192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ scrollTo; }
/* harmony export */ });
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90257);

var supportsNativeSmoothScroll = typeof document !== "undefined" && "scrollBehavior" in document.documentElement.style;
function scrollTo(param) {
    var element = param.element, _top = param.top, top = _top === void 0 ? 0 : _top, _left = param.left, left = _left === void 0 ? 0 : _left;
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)()) {
        return;
    }
    element = (element === null || element === void 0 ? void 0 : element.scrollTo) && typeof (element === null || element === void 0 ? void 0 : element.scrollTo) === "function" ? element : window;
    if (!element) {
        return;
    }
    if (supportsNativeSmoothScroll) {
        element.scrollTo({
            top: top,
            left: left,
            behavior: "smooth"
        });
        return;
    }
    try {
        element.scrollTo(left, top);
    } catch (error) {
        try {
            element.scrollTop = top;
            element.scrollLeft = left;
        } catch (error) {}
    }
};


/***/ }),

/***/ 50153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90257);


var useIsomorphicLayoutEffect = (0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)() ? react__WEBPACK_IMPORTED_MODULE_0__.useEffect : react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;
/* harmony default export */ __webpack_exports__["Z"] = (useIsomorphicLayoutEffect);


/***/ }),

/***/ 68441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ StoreName; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./src/data/queries/website/websiteMenuInformation.main.tsx + 1 modules
var websiteMenuInformation_main = __webpack_require__(41372);
// EXTERNAL MODULE: ./src/hooks/useWebsiteId.ts
var useWebsiteId = __webpack_require__(16825);
// EXTERNAL MODULE: ./node_modules/apollo-hooks/dist/apollo-hooks.es.js
var apollo_hooks_es = __webpack_require__(3172);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/page-components/Checkout/Checkout/Delivery/StoreName/useStoreName.main.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query storeNamePreferences($websiteId: ID!) {\n        preferences: userPreferences(websiteId: $websiteId) {\n          _id\n          store {\n            _id\n            fullName\n          }\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function useStoreName() {
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var preferences = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: (0,lib["default"])(_templateObject()),
        variables: {
            websiteId: websiteId
        },
        fetchPolicy: "cache-first"
    }).preferences;
    return preferences === null || preferences === void 0 ? void 0 : preferences.store;
};

// EXTERNAL MODULE: ./src/page-components/Checkout/Checkout/Delivery/StoreName/styles.module.css
var styles_module = __webpack_require__(12930);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/page-components/Checkout/Checkout/Delivery/StoreName/index.tsx






function StoreName(param) {
    var _showTitle = param.showTitle, showTitle = _showTitle === void 0 ? false : _showTitle, _isOnMenu = param.isOnMenu, isOnMenu = _isOnMenu === void 0 ? false : _isOnMenu, _isCheckoutV2 = param.isCheckoutV2, isCheckoutV2 = _isCheckoutV2 === void 0 ? false : _isCheckoutV2;
    var website = (0,websiteMenuInformation_main/* useWebsiteMenuInformation */.g9)().website;
    var store = useStoreName();
    var showStoreName = (website || {}).showStoreName;
    if (!showStoreName) return null;
    if (!store || !store.fullName) return null;
    var classNameComponent = (styles_module_default()).containerIcon;
    if (isOnMenu) {
        classNameComponent = (styles_module_default()).menu;
    }
    if (isCheckoutV2) {
        classNameComponent = (styles_module_default()).checkoutV2;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).title,
                children: "Local"
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classNameComponent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdStore */.moe, {
                        size: 20,
                        className: "mr-1"
                    }),
                    " ",
                    store.fullName
                ]
            })
        ]
    });
};


/***/ }),

/***/ 98812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Bar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(5434);
/* harmony import */ var _helpers_misc_classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89894);
/* harmony import */ var _helpers_misc_getQueryObject__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62280);
/* harmony import */ var _hooks_useDebounce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1003);
/* harmony import */ var _hooks_useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50153);
/* harmony import */ var _hooks_useKeyboardEvent__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1626);
/* harmony import */ var _hooks_useRef__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(53630);
/* harmony import */ var _hooks_useState__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48249);
/* harmony import */ var _packages_justo_parts_lib_components_Container__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(59848);
/* harmony import */ var _page_components_Order_CartV3_hooks_useCartV3__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47731);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(32533);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(42653);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_13__);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}















function Bar(props) {
    var filter = props.filter, setFilter = props.setFilter;
    var ref3 = _slicedToArray((0,_hooks_useState__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(filter), 2), localSearch = ref3[0], setLocalSearch = ref3[1];
    var ref1 = _slicedToArray((0,_hooks_useState__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(false), 2), searching = ref1[0], setSearching = ref1[1];
    var input = (0,_hooks_useRef__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(null);
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_12__/* .useTranslation */ .$G)("website").t;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_11__.useRouter)();
    var ref2 = _slicedToArray((0,_hooks_useDebounce__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(localSearch, 400), 2), debouncedFilter = ref2[0], isDebouncing = ref2[1];
    var isCartV3 = (0,_page_components_Order_CartV3_hooks_useCartV3__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)();
    (0,_hooks_useKeyboardEvent__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("Escape", function() {
        setSearching(false);
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        var q = (ref = (0,_helpers_misc_getQueryObject__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(router)) === null || ref === void 0 ? void 0 : ref.search;
        var qValue = Array.isArray(q) ? q[0] : q;
        if (qValue !== "" && filter !== qValue) {
            setFilter(qValue);
            setLocalSearch(qValue);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) // We want to do this only on load
    ;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (debouncedFilter !== filter) {
            var ref;
            setFilter(debouncedFilter);
            if (debouncedFilter && debouncedFilter !== ((ref = (0,_helpers_misc_getQueryObject__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(router)) === null || ref === void 0 ? void 0 : ref.search)) {
                var url = new URL(window.location.href);
                url.searchParams.set("search", debouncedFilter);
                window.history.pushState(null, "", url.toString());
            }
        }
    }, [
        debouncedFilter,
        setFilter,
        filter,
        router
    ]);
    (0,_hooks_useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
        if (searching) {
            input.current.focus();
        } else {
            setFilter("");
            setLocalSearch("");
        }
    }, [
        searching
    ]);
    var containerClassName = {
        v1: (_styles_module_css__WEBPACK_IMPORTED_MODULE_13___default().container),
        v2: (_styles_module_css__WEBPACK_IMPORTED_MODULE_13___default().withBarContainer),
        mobile: (0,_helpers_misc_classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_styles_module_css__WEBPACK_IMPORTED_MODULE_13___default().withBarContainerMobile), {
            "!top-0": isCartV3
        })
    }[props.layout];
    var content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_13___default().search),
                onClick: function() {
                    setSearching(!searching);
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_14__/* .MdSearch */ .vU7, {
                    size: 20
                })
            }),
            searching ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        ref: input,
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_13___default().input),
                        value: localSearch,
                        onChange: function(event) {
                            return setLocalSearch(event.target.value);
                        },
                        type: "text",
                        placeholder: t("order.labelSearchProduct")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_13___default().close),
                        onClick: function() {
                            return setSearching(!searching);
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_14__/* .MdClose */ .FU5, {
                            size: 20
                        })
                    })
                ]
            }) : props.children
        ]
    });
    if (props.layout === "v1") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: containerClassName,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_13___default().inner),
                children: content
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: containerClassName,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_packages_justo_parts_lib_components_Container__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_13___default().inner),
            children: content
        })
    });
};


/***/ }),

/***/ 10238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BrandBar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56036);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_3__);




function BrandBar(props) {
    var imgSrc = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(props, "brand.menuImage.url");
    var brandName = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(props, "brand.name");
    var altText = "Banner ".concat(brandName);
    var imgLink = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(props, "brand.link");
    if (!imgSrc) return null;
    if (imgLink) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: imgLink,
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full h-64 relative",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    layout: "fill",
                    objectFit: "contain",
                    alt: altText,
                    src: imgSrc
                })
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full h-64 relative",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            layout: "fill",
            objectFit: "contain",
            alt: altText,
            src: imgSrc
        })
    });
};


/***/ }),

/***/ 51888:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Categories; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Brands/BrandBar/styles.module.css
var styles_module = __webpack_require__(9474);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/Brands/BrandBar/index.tsx




function BrandBar(props) {
    var imgSrc = get_default()(props, "brand.categoriesImage.url");
    return imgSrc ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        className: (styles_module_default()).image,
        onClick: props.onClick,
        src: props.brand.categoriesImage.url
    }) : null;
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Categories/styles.module.css
var Categories_styles_module = __webpack_require__(23568);
var Categories_styles_module_default = /*#__PURE__*/__webpack_require__.n(Categories_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/Brands/index.tsx




function Categories(props) {
    if (!props.categories) return null;
    var lastBrandId = null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Categories_styles_module_default()).brandsContainer,
        children: props.categories.map(function(category) {
            var brand = null;
            if (category.brand && category.brand._id !== lastBrandId) {
                brand = category.brand;
                lastBrandId = brand._id;
            }
            var brandContent = brand ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandBar, {
                brand: brand,
                onClick: function() {
                    props.onClick();
                    props.scrollTo(category._id);
                }
            }) : null;
            if (!category.brand && lastBrandId) {
                lastBrandId = null;
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: brandContent
            }, category._id);
        })
    });
};


/***/ }),

/***/ 7078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Categories; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/helpers/misc/scrollTo.ts
var misc_scrollTo = __webpack_require__(55192);
// EXTERNAL MODULE: ./src/hooks/useEffect.ts
var useEffect = __webpack_require__(10338);
// EXTERNAL MODULE: ./src/hooks/useIsStore.ts + 2 modules
var useIsStore = __webpack_require__(68400);
// EXTERNAL MODULE: ./src/hooks/useRef.ts
var useRef = __webpack_require__(53630);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 50 modules
var esm = __webpack_require__(32533);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Categories/Dropdown/styles.module.css
var styles_module = __webpack_require__(93633);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/Categories/Dropdown/index.tsx







function Dropdown(param) {
    var name = param.name, ref = param.ref, subCategories = param.subCategories, className = param.className, id = param.id, scrollLeft = param.scrollLeft;
    var items = subCategories.items;
    var ref1 = (0,react.useState)(false), active = ref1[0], setActive = ref1[1];
    var internalRef = (0,react.useRef)();
    var finalRef = ref || internalRef;
    var t = (0,esm/* useTranslation */.$G)("generic").t;
    var subMenuStyle = function() {
        if (!finalRef.current) {
            return {
                display: "none"
            };
        }
        var _current = finalRef.current, offsetHeight = _current.offsetHeight, offsetLeft = _current.offsetLeft;
        return {
            position: "absolute",
            top: offsetHeight,
            left: (offsetLeft > scrollLeft ? offsetLeft - scrollLeft : offsetLeft) - 5
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).container,
        onMouseEnter: function() {
            return setActive(true);
        },
        onMouseLeave: function() {
            return setActive(false);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/pedir/category/".concat(id),
                prefetch: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    ref: finalRef,
                    style: active ? {
                        color: "var(--primary-color)"
                    } : {},
                    className: className,
                    children: [
                        name,
                        items.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdArrowDropDown */.gwH, {})
                    ]
                })
            }),
            active && items.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).subMenu,
                style: subMenuStyle(),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (styles_module_default()).internalContainer,
                    children: [
                        items.map(function(item, idx) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/pedir/category/".concat(item._id),
                                prefetch: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: classnames_default()((styles_module_default()).item, (styles_module_default()).grey, (styles_module_default()).clickable),
                                    children: item.name
                                })
                            }, idx);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/pedir/category/".concat(id),
                            prefetch: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: classnames_default()((styles_module_default()).item, (styles_module_default()).clickable),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (styles_module_default()).viewAll,
                                        children: [
                                            " ",
                                            t("fields.showAll"),
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdArrowForward */.hdK, {
                                        color: "red"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }) : null
        ]
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Categories/styles.module.css
var Categories_styles_module = __webpack_require__(23568);
var Categories_styles_module_default = /*#__PURE__*/__webpack_require__.n(Categories_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/Categories/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}









function Categories(props) {
    var activeCategoryId1 = props.activeCategoryId, categories = props.categories, layout = props.layout, onClick = props.onClick;
    var refs = (0,useRef/* default */.Z)({});
    var container = (0,useRef/* default */.Z)(null);
    var isStore = (0,useIsStore/* default */.Z)();
    var ref1 = (0,react.useState)(0), scrollLeft1 = ref1[0], setScrollLeft = ref1[1];
    var offsetLeft = {
        v1: 40,
        v2: 50,
        mobile: 50
    }[layout];
    var scrollTo = function(activeCategoryId) {
        var activeElement = refs.current[activeCategoryId];
        if (!activeElement) return;
        (0,misc_scrollTo/* default */.Z)({
            element: container.current,
            left: activeElement.offsetLeft - offsetLeft
        });
    };
    (0,useEffect/* default */.Z)(function() {
        if (!activeCategoryId1) return function() {};
        scrollTo(activeCategoryId1);
    }, [
        activeCategoryId1
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Categories_styles_module_default()).container,
        ref: container,
        onScroll: function(event) {
            if ((event === null || event === void 0 ? void 0 : event.target) && "scrollLeft" in event.target) {
                var scrollLeft = event === null || event === void 0 ? void 0 : event.target["scrollLeft"];
                setScrollLeft(scrollLeft);
            }
        },
        children: categories.map(function(category) {
            var childProps = {
                ref: function(ref) {
                    return refs.current[category._id] = ref;
                },
                key: category._id,
                className: activeCategoryId1 === category._id ? classnames_default()((Categories_styles_module_default()).active, "primaryColor") : classnames_default()((Categories_styles_module_default()).category, __webpack_require__.g.isDarkBackground ? (Categories_styles_module_default()).clearText : (Categories_styles_module_default()).darkText)
            };
            return isStore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown, _objectSpread({}, childProps, {
                id: category._id,
                name: category.name,
                subCategories: category.subCategories,
                scrollLeft: scrollLeft1
            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", _objectSpread({}, childProps, {
                onClick: function() {
                    onClick();
                    props.scrollTo(category._id);
                },
                children: category.name
            }));
        })
    });
};


/***/ }),

/***/ 82544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Filters; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _packages_justo_parts_lib_components_fields_Select__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97338);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32533);
/* harmony import */ var simple_react_form__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40191);
/* harmony import */ var simple_react_form__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(simple_react_form__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18783);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_6__);







var encode = function(val) {
    return JSON.stringify(val, null, 2);
};
var parse = function(val) {
    return JSON.parse(val);
};
var options = [
    {
        value: JSON.stringify(null),
        label: "Destacados"
    },
    {
        value: encode({
            type: "timesPurchased",
            order: "desc"
        }),
        label: "M\xe1s vendidos"
    },
    {
        value: encode({
            type: "price",
            order: "asc"
        }),
        label: "Precio menor a mayor"
    },
    {
        value: encode({
            type: "price",
            order: "desc"
        }),
        label: "Precio mayor a menor"
    },
    {
        value: encode({
            type: "name",
            order: "asc"
        }),
        label: "Ordenar A - Z"
    },
    {
        value: encode({
            type: "name",
            order: "desc"
        }),
        label: "Ordenar Z - A"
    }
];
function Filters(props) {
    var sorting = props.sorting, setSorting = props.setSorting, additionalClassname = props.additionalClassname;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)("website", {
        keyPrefix: "order.products.productsContent.filters"
    }).t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().container), additionalClassname ? additionalClassname : ""),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().order),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(simple_react_form__WEBPACK_IMPORTED_MODULE_5__.Field, {
                fieldName: "",
                placeholder: t("labelSort"),
                onChange: function(val) {
                    return setSorting(parse(val));
                },
                value: encode(sorting),
                type: _packages_justo_parts_lib_components_fields_Select__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
                options: options
            })
        })
    });
};


/***/ }),

/***/ 26642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NoBrandDivider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65626);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_2__);



function NoBrandDivider(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().container)
    });
};


/***/ }),

/***/ 12930:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"containerIcon":"hRpWX6Dx4r3Az4IQ5W6X8","checkoutV2":"a_EVOam_-Evgjc0A9MAoK","menu":"_1rMSWHLRq3jE0Rv3sDZPnk","title":"_1XdRvcxp83EKtHEynIUHZ5"};

/***/ }),

/***/ 42653:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_1SumNs9G2VhZ4R6NtF15oq categoriesBar backgroundColor backgroundBorderColor","inner":"_25HrABaLHeG06s6mkOpAm7","withBarContainer":"bD81skAySjzC_ASwSkC2b _1SumNs9G2VhZ4R6NtF15oq categoriesBar backgroundColor backgroundBorderColor","withBarContainerMobile":"_1CLebVj6of1hV8SdIjf6Mo _1SumNs9G2VhZ4R6NtF15oq categoriesBar backgroundColor backgroundBorderColor","search":"_2wKyk1TmtQj-2vyLxoIkyd","close":"_1IBcPTy_3aqJ-2HW-VgDYK _2wKyk1TmtQj-2vyLxoIkyd","input":"HleMUJooq_sNd-eQeWXcX backgroundColor textColor"};

/***/ }),

/***/ 9474:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"_2n863Ch04Xm6I8qOb9IjvQ"};

/***/ }),

/***/ 93633:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_2NJs8vcV8_JP1C6oknN0K3","subMenu":"_2yiHXcXaO-evCTfE4IXKJK","internalContainer":"sYm88FtY5wGLcyTFoWkdk","item":"K6aBAfOuNDTGqNFIP-T95","active":"_31EtZOEAQ1bdYZHv88zS9x","grey":"_2DpU06ipa0YUR4chynUSYN","viewAll":"_1mH2NZ6PCPVOkZ7wvAgsbf","clickable":"_2F4NXQIvtpGitxy5HqqN-7"};

/***/ }),

/***/ 23568:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3Y2myTiF1rA1_xi6R74uFB","brandsContainer":"_101cBxD0_Oz4Bfa41WR_6y _3Y2myTiF1rA1_xi6R74uFB","category":"PMmYJcjwi0OVUNEI3wkNH categoriesBarItem","clearText":"_4PCTlb8gArXihRSnEAHca","darkText":"_3JaOd-lSXh8Z8Ocy4x9ZN-","active":"_1FOW7HfIed5hxwHYDkhbXo PMmYJcjwi0OVUNEI3wkNH categoriesBarItem categoriesBarItemActive textColor"};

/***/ }),

/***/ 18783:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_-92tf-wuo2Yx2KOPmRavk","order":"_3Uny8y42CnRrBgpzjd5MXw"};

/***/ }),

/***/ 65626:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3sS7KGUyRNVeZF9rsBhlDv"};

/***/ })

}]);